<div class="notification is-primary is-light mb-4">
  <div class="columns">
    <div class="column">
      <h5 class="title is-5 mb-2" [translate]="title()"></h5>
      <ng-content></ng-content>
    </div>
    <div
      class="column is-1 is-flex is-justify-content-center is-align-items-center"
    >
      <div class="info-circle">
        <fino-icon icon="Information Circle" class="icon"></fino-icon>
      </div>
    </div>
  </div>
</div>
